
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// --- Error Boundary: Catches unhandled React errors gracefully ---
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error: Error | null }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Application Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: '#0f172a', color: '#e2e8f0', fontFamily: 'system-ui, sans-serif', padding: '2rem'
        }}>
          <div style={{ maxWidth: '480px', textAlign: 'center' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⚠️</div>
            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: '0.5rem' }}>
              Ein unerwarteter Fehler ist aufgetreten
            </h2>
            <p style={{ color: '#94a3b8', fontSize: '0.875rem', marginBottom: '1.5rem' }}>
              Bitte laden Sie die Seite neu. Sollte das Problem bestehen bleiben, kontaktieren Sie den Support.
            </p>
            <button 
              onClick={() => window.location.reload()} 
              style={{
                padding: '0.75rem 2rem', background: '#3b82f6', color: 'white', border: 'none',
                borderRadius: '0.5rem', fontWeight: 600, cursor: 'pointer', fontSize: '0.875rem'
              }}
            >
              Seite neu laden
            </button>
            {this.state.error && (
              <pre style={{ 
                marginTop: '1.5rem', background: 'rgba(239,68,68,0.1)', padding: '1rem', 
                borderRadius: '0.5rem', fontSize: '0.7rem', textAlign: 'left', 
                color: '#fca5a5', overflow: 'auto', maxHeight: '200px'
              }}>
                {this.state.error.message}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
